"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorrelationHttpClient = void 0;
const index_1 = require("../Types/index");
const BaseClient_1 = require("./BaseClient");
class CorrelationHttpClient extends BaseClient_1.BaseClient {
    async getAll(identity, includeProcessInstances, offset, limit, sortSettings) {
        let urlRestPart = index_1.restSettings.paths.getCorrelations;
        if (includeProcessInstances) {
            urlRestPart = `${urlRestPart}?includeProcessInstances=${includeProcessInstances}`;
        }
        const url = this.buildUrl(urlRestPart, offset, limit, null, sortSettings);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        return response.result;
    }
    async getById(correlationId, identity, includeProcessInstances) {
        let urlRestPart = index_1.restSettings.paths.getCorrelationById.replace(index_1.restSettings.params.correlationId, correlationId);
        if (includeProcessInstances) {
            urlRestPart = `${urlRestPart}?includeProcessInstances=${includeProcessInstances}`;
        }
        const url = this.buildUrl(urlRestPart);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        return response.result;
    }
}
exports.CorrelationHttpClient = CorrelationHttpClient;
//# sourceMappingURL=CorrelationHttpClient.js.map